

  import { MsgExecuteContract } from "@goblinhunt/cosmes/client"; 
  import {
    StationController,
    KeplrController,
    GalaxyStationController,
    LUNCDashController,
    WalletType
  } from "@goblinhunt/cosmes/wallet";
  
class CookiePaymentInitiator {
  constructor(projectId) { 
    this.chainId = 'columbus-5';
    this.rpcEndpoint = 'https://terra-classic-rpc.publicnode.com';
    this.lcdEndpoint = 'https://terra-classic-lcd.publicnode.com';
    this.DENOM = 'uluna';
    this.projectId = projectId;
    this.senderAddress = null;
    this.wallet = null;
    this.walletType = null;
    this.walletConnectType = null;
    this.onWalletConnected = new EventTarget(); // Event emitter for wallet connection
    this.onWalletDisconnected = new EventTarget(); // Event emitter for wallet disconnection

    // Initialize controllers
    this.CONTROLLERS = {
      'station': new StationController(this.projectId),
      'keplr': new KeplrController(this.projectId),
      'galaxy': new GalaxyStationController(this.projectId),
      'dash': new LUNCDashController(this.projectId)
    };
  }

  async connectWallet(preferredWallet = 'keplr', walletConnectType = 'extension') {
    try {
      const controller = this.CONTROLLERS[preferredWallet];
      if (!controller) {
        throw new Error('Invalid wallet type');
      }

      // Register disconnect handler
      controller.onDisconnect((wallets) => {
        this.wallet = null;
        this.senderAddress = null;
      });

      // Register account change handler
      controller.onAccountChange((wallets) => {
        // Reconnect with new account
        this.connectWallet(preferredWallet, walletConnectType);
      });

      const chainInfo = {
        chainId: this.chainId,
        rpc: this.rpcEndpoint,
        gasPrice: { amount: "28.325", denom: this.DENOM }
      };

      // Connect using the appropriate type
      const type = walletConnectType === 'walletconnect' ? 
        WalletType.WALLETCONNECT : 
        WalletType.EXTENSION;

      const connectedWallets = await controller.connect(type, [chainInfo]);
      
      // Convert Map to object and get the wallet for our chain
      const walletsObj = Object.fromEntries(connectedWallets);
      this.wallet = walletsObj[this.chainId];

      if (!this.wallet) {
        throw new Error('Failed to connect wallet');
      }

      this.senderAddress = this.wallet.address;
      this.walletType = preferredWallet;
      this.walletConnectType = walletConnectType;

      // Dispatch a custom event when the wallet is connected
      const connectedEvent = new CustomEvent('connected', { detail: { wallet: this.connectedWallet, address: this.senderAddress } });
      this.onWalletConnected.dispatchEvent(connectedEvent);
      
      return [this.senderAddress, this.wallet];

    } catch (error) {
      console.error('Wallet connection error:', error);
      if (error.message.includes('No valid wallet connected')) {
        throw new Error('Please install the required wallet extension (Keplr or Station) or ensure that the WalletConnect QR code can be scanned.');
      }
      throw error;
    }
  }
}
export default CookiePaymentInitiator;